import { NotificationManager } from 'react-notifications';
import qrCode from 'qrcode';

import { authFetch } from "../../utils/authFetch";
import {
  setAccessToken,
  setRefreshToken,
  getRefreshToken,
  clearAllTokens
} from "../../utils/authToken";

const apiURL = require('./apiURL');
// const apiURL = "http://localhost:3000"

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];




// types of action
const Types = {
  AUTHENTICATION_LOGIN: "AUTHENTICATION_LOGIN",
  AUTHENTICATION_PROCESSING: "AUTHENTICATION_PROCESSING",
  AUTHENTICATION_LOGOUT: "AUTHENTICATION_LOGOUT",
  AUTHENTICATION_SHOW_MODAL: "AUTHENTICATION_SHOW_MODAL",
  AUTHENTICATION_VALIDATE_CODE: "AUTHENTICATION_VALIDATE_CODE",
  AUTHENTICATION_RECOVERY_CODE_CHECK: "AUTHENTICATION_RECOVERY_CODE_CHECK",
  AUTHENTICATION_SETTING_PASSWORD: "AUTHENTICATION_SETTING_PASSWORD",
  AUTHENTICATION_SET_PASSWORD_RESULT: "AUTHENTICATION_SET_PASSWORD_RESULT",
  AUTHENTICATION_AVAILABLE_ORGANISATIONS: "AUTHENTICATION_AVAILABLE_ORGANISATIONS",
  AUTHENTICATION_SET_MFA_EXPIRY: "AUTHENTICATION_SET_MFA_EXPIRY",
  AUTHENTICATION_SET_MFA: "AUTHENTICATION_SET_MFA",
  AUTHENTICATION_MFA_VERIFIED: "AUTHENTICATION_MFA_VERIFIED",
  AUTHENTICATION_MFA_MODAL_STATUS: "AUTHENTICATION_MFA_MODAL_STATUS",
};


const buildFormData = (formData, data, parentKey) => {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    const value = data == null ? '' : data;

    formData.append(parentKey, value);
  }
}

const setAvailableOrganisations = (organisations) => ({
  type: Types.AUTHENTICATION_AVAILABLE_ORGANISATIONS,
  organisations,
});

const getAvailableOrganisations = () => {
  return (dispatch, getState) => {

    const state = getState()

    authFetch(apiURL + '/authentication/organisations?withBalance=1' , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(setAvailableOrganisations(data))
    })
  }
}

const toggleLoginModal = (status) => ({
  type: Types.AUTHENTICATION_SHOW_MODAL,
  status,
});

const loggingIn = (saving) => ({
  type: Types.AUTHENTICATION_PROCESSING,
  saving,
});

const updateLoginStatus = (response,attempt) => ({
  type: Types.AUTHENTICATION_LOGIN,
  payload: response,
  attempt
});

const setLogout = (response) => ({
  type: Types.AUTHENTICATION_LOGOUT,
  payload: response
});

const login = (username,password) => {
  return (dispatch, getState) => {

    const state = getState()

    if (state.authentication.processing){
      return;
    }

    dispatch(loggingIn(true))

    authFetch(apiURL + '/authentication/login' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({username,password}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    }, { skipAuth: true, skipRefresh: true })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      if (data.accessToken) {
        setAccessToken(data.accessToken);
      } else if (data.token) {
        setAccessToken(data.token);
      }

      if (data.refreshToken) {
        setRefreshToken(data.refreshToken);
      }

      if (data.profile){
        dispatch(getAvailableOrganisations())
      }
      dispatch(updateLoginStatus(data,true))
    })
  }
}

const createHandoffCode = (portal) => {
  return async () => {
    const response = await authFetch(apiURL + '/authentication/handoff', {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({ portal }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error("Unable to create handoff code");
    }

    const data = await response.json();
    return data.code || data.handoffCode;
  };
};

const externalAppLogin = ({ email, externalId, appName, token }) => {
  return (dispatch, getState) => {

    const state = getState();

    if (state.authentication.processing){
      return;
    }

    dispatch(loggingIn(true));

    authFetch(apiURL + `/authentication/${appName}/login` , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({ email }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token': token,
          'x-external-id': externalId,
        },
    }, { skipAuth: true, skipRefresh: true })
    .then(response => response.json())
    .then(data => {
      if (data.accessToken) {
        setAccessToken(data.accessToken);
      } else if (data.token) {
        setAccessToken(data.token);
      }

      if (data.refreshToken) {
        setRefreshToken(data.refreshToken);
      }

      if (data.profile){
        dispatch(getAvailableOrganisations());
      }

      dispatch(updateLoginStatus(data,true));
    })
    .catch(err => {
      console.error(err);
      NotificationManager.error("Something went wrong!", "Error");
      dispatch(loggingIn(false));
    });
  }
}

const validatingCode = () => ({
  type: Types.AUTHENTICATION_VALIDATE_CODE,
});

const validatingCodeCheck = (response) => ({
  type: Types.AUTHENTICATION_RECOVERY_CODE_CHECK,
  payload: response,
});

const validateCode = () => {
  return (dispatch, getState) => {
    const formData = new FormData();

    const state = getState()
    dispatch(validatingCode(true))

    const code = window.location.pathname.split('/')[3]

    authFetch(apiURL + `/authentication/recovery-check/${code}` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(validatingCodeCheck(data))
    })
  }
}

const settingPassword = () => ({
  type: Types.AUTHENTICATION_SETTING_PASSWORD,
});

const setPasswordResult = (response) => ({
  type: Types.AUTHENTICATION_SET_PASSWORD_RESULT,
  payload: response,
});


const setPassword = (username,password,confirmPassword) => {
  return (dispatch, getState) => {
    const formData = new FormData();

    const state = getState()
    dispatch(settingPassword(true))


    // const data = {
    //   'action[members-reset-password]': true,
    //   'fields[email]': username,
    //   'fields[password][recovery-code]': window.location.pathname.split('/')[3],
    //   'fields[password][password]': password,
    //   'fields[password][confirm]': confirmPassword,
    //   'employee': true
    // }

    // buildFormData(formData, data);

    // fetch("https://buddy.hr/ajax/" , {
    authFetch(apiURL + `/authentication/reset` , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({
          code: window.location.pathname.split('/')[3],
          password
        }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(setPasswordResult(data))
      window.location.href = "/login"
    }).catch(err => {
      dispatch(setPasswordResult({error: "Unable to save your password"}))
      // console.log('err',err)
      // window.location.href = '/'
    })
  }
}

const resetPassword = (username) => {
  return (dispatch, getState) => {
    const formData = new FormData();

    const state = getState()

    if (state.authentication.processing){
      return;
    }

    dispatch(loggingIn(true))

    authFetch(apiURL + "/settings/reset-password" , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({username}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      window.location.href = '/'
      console.log('resetPassword', username)
    });
  }
}

const logout = () => {
  return (dispatch, getState) => {

    const state = getState()

    if (state.authentication.processing){
      return;
    }
    
    dispatch(loggingIn(true))

    authFetch(apiURL + '/authentication/logout' , {
        credentials: 'include',
        method: 'POST',
        // body: JSON.stringify({username,password}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      clearAllTokens();
      dispatch(setLogout(data))
    })
  }
}

const isLoggedIn = () => {
  return (dispatch, getState) => {

    const state = getState()
    const refreshToken = getRefreshToken();
    if (!refreshToken) {
      dispatch(loggingIn(false))
      return;
    }

    dispatch(loggingIn(true))

    authFetch(apiURL + '/authentication/refresh' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({ refreshToken }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
    }, { skipAuth: true, skipRefresh: true })
    .then(response => {
      if (!response.ok) {
        throw new Error("Unable to refresh session");
      }
      return response.json();
    })
    .then(data => {
      if (data.token) {
        setAccessToken(data.token);
      } else if (data.accessToken) {
        setAccessToken(data.accessToken);
      }

      if (data.refreshToken) {
        setRefreshToken(data.refreshToken);
      }

      return authFetch(apiURL + '/authentication/status' , {
          credentials: 'include',
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)

      if (data.profile){
        dispatch(getAvailableOrganisations())
      }
      dispatch(updateLoginStatus(data,false))
    })
    .catch(e => {
      clearAllTokens();
      console.log(e)
    })
  }
}

const goToZendesk = () => {
  return (dispatch, getState) => {

    const state = getState()
    dispatch(loggingIn(true))

    authFetch(apiURL + '/authentication/zendesk' , {
        credentials: 'include',
        method: 'GET',
        // body: JSON.stringify({username,password}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('zendesktoken data',data)

      if (data.token){

        const currentParams =  new URLSearchParams(window.location.search.substring(1));

        const newParams =  new URLSearchParams();
        console.log('')
        newParams.set('jwt', data.token)
        newParams.set('return_to', currentParams.get('return_to'))

        window.location.href = `https://buddyhr.zendesk.com/access/jwt?${newParams.toString()}`
      }
    })
  }
}

const setMfaExpiry = (expiry) => ({
  type: Types.AUTHENTICATION_SET_MFA_EXPIRY,
  expiry
});

const checkMFA = (code) => {
  return (dispatch, getState) => {

    authFetch(apiURL + '/authentication/mfa/check' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({ code }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
      console.debug(data)
      if(data.success) {
        dispatch(setMfaExpiry(data.mfaExpires));
        NotificationManager.success("Successfully Authenticated!", "Success");
      } else if(!data.error) {
        console.debug("Invalid MFA Code", "Error")
        NotificationManager.error("Invalid MFA Code", "Error");
      } else {
        NotificationManager.error("An unknown error occurred", "Error");
      }
    })
  }
}

const setMFA = (payload) => ({
  type: Types.AUTHENTICATION_SET_MFA,
  payload
});

const mfaVerified = (status) => ({
  type: Types.AUTHENTICATION_MFA_VERIFIED,
  status
});

const setMFAModalStatus = (status) => ({
  type: Types.AUTHENTICATION_MFA_MODAL_STATUS,
  status
});

const createQRCode = async (data) => {
  return new Promise(async (resolve, reject) => {
    const qr = await qrCode.toDataURL(data, {
      width: 1200,
      scale: 0.5,
      type: "image/png",
      margin: 0
    });
    if(qr) resolve(qr);
    else resolve(null);
  });
}


const initiateMFA = () => {
  return (dispatch, getState) => {

    const state = getState();

    authFetch(apiURL + '/authentication/mfa/enable' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify?.({ email: state?.my?.profile?.email }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
      if(data.url && data.secret) {
        createQRCode(data.url).then((qrData) => {
          if(qrData) dispatch(setMFA({...data, qrImg: qrData}));
          else console.error("Error occurred in QR Code generation!", data);
        });
      }
    })
  }
}

const verifyMFA = (code) => {
  return (dispatch, getState) => {

    const state = getState();

    const { secret } = state?.my?.mfa?.setup;
    authFetch(apiURL + '/authentication/mfa/verify' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({ code, secret }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(mfaVerified(!!data.verified));
      if(!data.error && data.success) {
        dispatch(setMFAModalStatus(false));
        dispatch(setMfaExpiry(data.mfaExpires));
        NotificationManager.success("MFA Verified Successfully!", "Success");
        dispatch(setMFA(null));
      } else {
        NotificationManager.error("Something went wrong!", "Error");
      }
    })
  }
}



const Actions = {
  login,
  isLoggedIn,
  logout,
  resetPassword,
  setPassword,
  goToZendesk,
  validateCode,
  checkMFA,
  initiateMFA,
  verifyMFA,
  getAvailableOrganisations,
  externalAppLogin,
  createHandoffCode,
}

// exports = {
//   Types,
//   Actions
// }

export {Types, Actions}

// exports.Types = Types
// exports.Actions = Actions